import * as Sentry from "@sentry/react";
import { APP_ENV, SENTRY_DSN, SENTRY_RELEASE } from "@/config";

export const initSentry = () => {
    const isStaging = APP_ENV === "staging";
    const isProduction = APP_ENV === "production";

    if (!SENTRY_DSN) return;
    if (isStaging || isProduction) {
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: APP_ENV,
            release: SENTRY_RELEASE,
            integrations: [Sentry.browserTracingIntegration()],
            tracesSampleRate: isProduction ? 0.2 : 0.05,
        });
    }
};
